import React from "react";
import "./Stepper.css";

/* Horizontal progress stepper for multi-step forms.

   steps        [{ key, label, hint? }]
   current      index of the active step
   completed    Set / array of step keys that are done (shown with a tick)
   invalid      Set / array of step keys that have an error (shown in red)
   canSelect    (index) => boolean - may the user jump to this step? default: completed or earlier
   onSelect     (index) => void

   Renders a <nav><ol>; the active step carries aria-current="step". */
function Stepper({ steps, current, completed = [], invalid = [], canSelect, onSelect }) {
  const done = new Set(completed);
  const bad = new Set(invalid);

  return (
    <nav className="ustepper" aria-label="Progress">
      <ol className="ustepper-list">
        {steps.map((s, i) => {
          const isActive = i === current;
          const isDone = done.has(s.key) && !isActive;
          const isBad = bad.has(s.key) && !isActive;
          const selectable = canSelect ? canSelect(i) : i <= current || isDone;
          const state = isActive ? "active" : isBad ? "invalid" : isDone ? "done" : "todo";
          return (
            <li key={s.key} className={`ustepper-item is-${state}`}>
              <button
                type="button"
                className="ustepper-btn"
                aria-current={isActive ? "step" : undefined}
                disabled={!selectable}
                onClick={() => selectable && onSelect && onSelect(i)}
              >
                <span className="ustepper-dot" aria-hidden="true">
                  {isDone ? "✓" : isBad ? "!" : i + 1}
                </span>
                <span className="ustepper-text">
                  <span className="ustepper-label">{s.label}</span>
                  {s.hint && <span className="ustepper-hint">{s.hint}</span>}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Stepper;
